import * as React from "react";
import { Lottie, ReactLottieConfig } from "@crello/react-lottie";
import loadingData from "./data.json";

interface LoadingCtrlProps {
  className?: string;
  loading?: boolean;
  size?: string;
}

export const LoadingCtrl: React.FC<LoadingCtrlProps> = (props) => {
  const defaultOptions: ReactLottieConfig = {
    loop: true,
    autoplay: false,
    renderer: "canvas",
    animationData: JSON.parse(JSON.stringify(loadingData)),
  };

  return (
    <div className={props.className}>
      <Lottie
        config={defaultOptions}
        height={props.size ? props.size : "116px"}
        width={props.size ? props.size : "116px"}
        playingState={!props.loading ? "paused" : "playing"}
        // isClickToPauseDisabled={true}
      />
    </div>
  );
};

export default LoadingCtrl;
